module.exports = __webpack_public_path__ + "img/agsat.ce96d8bc.png";